module.exports = __webpack_public_path__ + "assets/img/img_2023.89657d22.jpg";